import React from "react";
import PropTypes from "prop-types";
import { DialogOverlay, DialogContent } from "@reach/dialog";
import { Transition } from "react-transition-group";
import classNames from "classnames";

const DURATION = 200;

// use @reach/dialog for a11y reasons
const Modal2 = ({
  isOpen,
  onClose,
  overlayClassName,
  contentClassName,
  overlayStyle,
  contentStyle,
  children,
  duration = DURATION,
  transitionProps,
  disableAnimation,
  ...props
}) => {
  // CSSTransition wouldn't work for me so just applied the classNames manually
  // TODO: fix exit transition
  return (
    <Transition in={isOpen} timeout={duration} appear={true} unmountOnExit mountOnEnter {...transitionProps}>
      {state => (
        <DialogOverlay className={overlayClassName} isOpen={isOpen} onDismiss={onClose} style={overlayStyle}>
          <DialogContent
            style={contentStyle}
            className={classNames({ "et--modal2": !disableAnimation }, contentClassName, state)}
          >
            {children}
          </DialogContent>
        </DialogOverlay>
      )}
    </Transition>
  );
};

Modal2.propTypes = {
  children: PropTypes.any,
  contentClassName: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  overlayClassName: PropTypes.string,
  overlayStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  duration: PropTypes.number,
  transitionProps: PropTypes.object,
  disableAnimation: PropTypes.bool,
};

export default Modal2;
